import React, { FC } from 'react';
import usePageBreadcrumbs from '../../hooks/usePageBreadcrumbs';
import * as StyledBreadcrumbs from './breadcrumbs.styles';

interface Props {
	pageId: number;
}

const Breadcrumbs: FC<Props> = ({ pageId }) => {
	const breadcrumbs = usePageBreadcrumbs(pageId);

	return (
		<StyledBreadcrumbs.Wrapper>
			{breadcrumbs &&
				breadcrumbs.map((item, index) => {
					const itemName = item.Name.substring(0, 35).concat(item.Name.length > 35 ? '...' : '');
					return (
						<StyledBreadcrumbs.Breadcrumb key={item.Id}>
							{index < breadcrumbs.length - 1 && (
								<>
									<StyledBreadcrumbs.BreadcrumbLink to={item.Url}>
										{itemName}
									</StyledBreadcrumbs.BreadcrumbLink>
									<StyledBreadcrumbs.BreadcrumbSep>/</StyledBreadcrumbs.BreadcrumbSep>
								</>
							)}
							{index === breadcrumbs.length - 1 && (
								<StyledBreadcrumbs.BreadcrumbLastLink>{itemName}</StyledBreadcrumbs.BreadcrumbLastLink>
							)}
						</StyledBreadcrumbs.Breadcrumb>
					);
				})}
		</StyledBreadcrumbs.Wrapper>
	);
};

export default Breadcrumbs;
